module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/087-aland-islands-82efd4609f214f46d1aa057b5115bcd7.svg";